export default __webpack_public_path__ + "static/media/avesha-thumbnail.2363f362.png";